import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, Router, NavigationExtras } from '@angular/router';
import { DatePipe, NgIf, NgFor, NgClass } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FoodService, MealInsightsResponse } from '../food.service';
import { ToastService } from '../../../../../services/toast.service';
declare var $: any;
@Component({
  selector: 'app-all-logs',
  standalone: true,
  imports: [MatListModule, MatIconModule, RouterLink, NgIf, NgFor, NgClass, DatePipe],
  templateUrl: './all-logs.component.html',
  styleUrl: './all-logs.component.css'
})
export class AllLogsComponent implements AfterViewInit {

  @Input() foodAllInfo: any;
  @Input() member: any;
  @Input() startDate: any;
  @Input() endDate: any;
  @Input() selectedType: any;
  @Input() highlightId: any;
  @Input() parentDate: any;
  @Output() deleted = new EventEmitter<void>();
  Math = Math;
  @ViewChild('foodLogCard') foodLogCard?: ElementRef<HTMLDivElement>;
  isHighlighted = false;

  // Meal Insights properties
  mealInsights: MealInsightsResponse['mealInsights'] | null = null;
  isLoadingInsights = false;
  insightsError = false;

  constructor(
    private datePipe: DatePipe,
    private router: Router,
    private foodService: FoodService,
    private toast: ToastService,
    private sanitizer: DomSanitizer
  ) {

  }
  getDate(selectedTime: any) {
    const timeParts = selectedTime.split(':');
    const selectedDate = new Date();
    selectedDate.setHours(parseInt(timeParts[0], 10));
    selectedDate.setMinutes(parseInt(timeParts[1], 10));
    return this.datePipe.transform(selectedDate, 'hh:mm a');
  }
  showModal(src: string) {
    var p = document.getElementById('modalImg');
    if (p instanceof HTMLImageElement) {
      p.src = src;
    }
    $('#imgModal1').modal('show');
  }

  closeModal() {
    $('#imgModal1').modal('hide');
  }

  ngAfterViewInit(): void {
    if (this.highlightId && this.foodAllInfo && this.foodAllInfo.id === this.highlightId) {
      this.applyHighlight();
    }
  }

  navigateToEdit(event: Event, foodAllInfo: any): void {
    event.preventDefault();
    const navigationExtras: NavigationExtras = {
      queryParams: {
        id: foodAllInfo.id,
        memberId: this.member
      },
      state: {
        stateObj: {
          selectedMainTab: 'lifestyle',
          selectedLifestyleTab: 'nutrition',
          nutritionStartDate: this.startDate,
          nutritionEndDate: this.endDate,
          selectedNutritionType: this.selectedType,
          selectedFoodLogId: foodAllInfo.id,
          anchorDate: this.parentDate
        }
      }
    };
    this.router.navigate(['/edit-food-log'], navigationExtras);
  }

  openDeleteModal(event: Event): void {
    event.preventDefault();
    if (!this.foodAllInfo?.id) {
      return;
    }
    $('#deleteFoodLogModal-' + this.foodAllInfo.id).modal('show');
  }
  cancelDelete(): void {
    if (!this.foodAllInfo?.id) {
      return;
    }
    $('#deleteFoodLogModal-' + this.foodAllInfo.id).modal('hide');
  }
  confirmDelete(): void {
    if (!this.foodAllInfo?.id || !this.member || !this.parentDate) {
      this.toast.errorMessage('Missing food log details to delete');
      return;
    }
    this.foodService.deleteFoodLog(this.foodAllInfo.id, this.member, this.parentDate).subscribe({
      next: (resp: any) => {
        if (resp === 1) {
          this.toast.errorMessage('Error while deleting food log. Please try again');
        } else {
          this.toast.successMessage('Food log deleted successfully');
          $('#deleteFoodLogModal-' + this.foodAllInfo.id).modal('hide');
          this.deleted.emit();
        }
      },
      error: () => {
        this.toast.errorMessage('Error while deleting food log. Please try again');
      }
    });
  }
  private applyHighlight(): void {
    this.isHighlighted = true;
    if (this.foodLogCard && this.foodLogCard.nativeElement) {
      setTimeout(() => {
        this.foodLogCard?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 200);
      setTimeout(() => {
        this.isHighlighted = false;
      }, 4000);
    }
  }

  openMealInsightsModal(event: Event): void {
    event.preventDefault();
    if (!this.foodAllInfo?.id) {
      return;
    }
    this.isLoadingInsights = true;
    this.insightsError = false;
    this.mealInsights = null;

    $('#mealInsightsModal-' + this.foodAllInfo.id).modal('show');

    this.foodService.getMealInsights(this.foodAllInfo.foodReadingId).subscribe({
      next: (response) => {
        this.isLoadingInsights = false;
        if (response && response.mealInsights) {
          this.mealInsights = response.mealInsights;
        } else {
          this.insightsError = true;
        }
      },
      error: () => {
        this.isLoadingInsights = false;
        this.insightsError = true;
      }
    });
  }

  closeMealInsightsModal(): void {
    if (!this.foodAllInfo?.id) {
      return;
    }
    $('#mealInsightsModal-' + this.foodAllInfo.id).modal('hide');
  }

  getScoreColor(score: number): string {
    if (score >= 70) return '#4CAF50';
    if (score >= 40) return '#FF9800';
    return '#F44336';
  }

  hasJournaling(): boolean {
    return !!(this.foodAllInfo?.journalingPrompt || this.foodAllInfo?.journalingNote);
  }

  openJournalingModal(event: Event): void {
    event.preventDefault();
    if (!this.foodAllInfo?.id) {
      return;
    }
    $('#journalingModal-' + this.foodAllInfo.id).modal('show');
  }

  closeJournalingModal(): void {
    if (!this.foodAllInfo?.id) {
      return;
    }
    $('#journalingModal-' + this.foodAllInfo.id).modal('hide');
  }

  formatJournalNotesDisplay(notes: string | null | undefined): string {
    if (notes == null || notes === '') {
      return '';
    }
    let s = notes;
    s = s.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n').replace(/\\r/g, '\n').replace(/\\t/g, '\t');
    s = s.replace(/\\u([dD][89a-fA-F][0-9a-f]{2})\\u([dD][c-fC-F][0-9a-f]{2})/g, (_, hi, lo) => {
      const h = parseInt(hi, 16);
      const l = parseInt(lo, 16);
      return String.fromCodePoint((h - 0xd800) * 0x400 + (l - 0xdc00) + 0x10000);
    });
    s = s.replace(/\\u([0-9a-fA-F]{4})/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
    return s;
  }

  getJournalNotesHtml(notes: string | null | undefined): SafeHtml {
    if (notes == null || notes === '') {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.buildJournalNotesHtml(notes));
  }

  private buildJournalNotesHtml(raw: string): string {
    const normalized = this.formatJournalNotesDisplay(raw);
    const re = /<\s*u\b[^>]*>([\s\S]*?)<\s*\/\s*u\s*>/gi;
    const parts: { u: boolean; body: string }[] = [];
    let lastIdx = 0;
    let m: RegExpExecArray | null;
    while ((m = re.exec(normalized)) !== null) {
      if (m.index > lastIdx) {
        parts.push({ u: false, body: normalized.slice(lastIdx, m.index) });
      }
      parts.push({ u: true, body: m[1] });
      lastIdx = re.lastIndex;
    }
    if (lastIdx < normalized.length) {
      parts.push({ u: false, body: normalized.slice(lastIdx) });
    }
    if (parts.length === 0) {
      parts.push({ u: false, body: normalized });
    }
    let out = '';
    for (const p of parts) {
      const inner = this.journalInlineToHtml(p.body);
      out += p.u ? `<u class="journal-note-u">${inner}</u>` : inner;
    }
    return out;
  }

  private escapeHtml(s: string): string {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  private journalInlineToHtml(fragment: string): string {
    let h = this.escapeHtml(fragment);
    h = h.replace(/\*\*([\s\S]*?)\*\*/g, '<strong>$1</strong>');
    h = h.replace(/_([\s\S]*?)_/g, '<em>$1</em>');
    h = h.replace(/\r\n|\n|\r/g, '<br/>');
    return h;
  }

  hasUpfFood(): boolean {
    if (!this.foodAllInfo?.foodItems) {
      return false;
    }
    return this.foodAllInfo.foodItems.some((food: any) => food.isUpf === true);
  }

  isBarcodeScan(): boolean {
    return this.foodAllInfo?.source === 'barcode_scan';
  }

  hasAlcoholInfo(): boolean {
    if (!this.foodAllInfo?.foodItems) {
      return false;
    }
    return this.foodAllInfo.foodItems.some((food: any) =>
      (food.nutrition?.alcoholGrams != null && food.nutrition.alcoholGrams > 0) ||
      (food.nutrition?.alcoholAbv != null && food.nutrition.alcoholAbv > 0) ||
      food.nutrition?.isAlcoholic === true
    );
  }

  getAlcoholAbv(): string {
    if (!this.foodAllInfo?.foodItems) {
      return '0';
    }
    const alcoholItem = this.foodAllInfo.foodItems.find((food: any) =>
      food.nutrition?.alcoholAbv != null && food.nutrition.alcoholAbv > 0
    );
    return alcoholItem ? alcoholItem.nutrition.alcoholAbv.toFixed(1) : '0';
  }

  getAlcoholGrams(): string {
    if (!this.foodAllInfo?.foodItems) {
      return '0';
    }
    const totalAlcohol = this.foodAllInfo.foodItems.reduce((sum: number, food: any) => {
      const qty = parseFloat(food.serving?.quantity) || 1;
      return sum + ((food.nutrition?.alcoholGrams || 0) * qty);
    }, 0);
    return totalAlcohol.toFixed(1);
  }

  hasCaffeineInfo(): boolean {
    if (!this.foodAllInfo?.foodItems) {
      return false;
    }
    return this.foodAllInfo.foodItems.some((food: any) =>
      food.nutrition?.caffeine != null && food.nutrition.caffeine > 0
    );
  }

  getCaffeineAmount(): string {
    if (!this.foodAllInfo?.foodItems) {
      return '0';
    }
    const totalCaffeine = this.foodAllInfo.foodItems.reduce((sum: number, food: any) => {
      const qty = parseFloat(food.serving?.quantity) || 1;
      return sum + ((food.nutrition?.caffeine || 0) * qty);
    }, 0);
    return totalCaffeine.toFixed(0);
  }

  getCaffeinatedItemCount(): number {
    if (!this.foodAllInfo?.foodItems) return 0;
    return this.foodAllInfo.foodItems.filter((food: any) =>
      food.nutrition?.caffeine != null && food.nutrition.caffeine > 0
    ).length;
  }

  getAlcoholicItemCount(): number {
    if (!this.foodAllInfo?.foodItems) return 0;
    return this.foodAllInfo.foodItems.filter((food: any) =>
      food.nutrition?.alcoholAbv != null && food.nutrition.alcoholAbv > 0
    ).length;
  }

  getAlcoholAbvRange(): { min: number; max: number } {
    if (!this.foodAllInfo?.foodItems) return { min: 0, max: 0 };
    const abvValues = this.foodAllInfo.foodItems
      .map((food: any) => food.nutrition?.alcoholAbv || 0)
      .filter((abv: number) => abv > 0);
    if (abvValues.length === 0) return { min: 0, max: 0 };
    return {
      min: Math.min(...abvValues),
      max: Math.max(...abvValues)
    };
  }

  getTotalServingSize(): string {
    // For single-item logs, use FoodLogs.Serving
    if (this.foodAllInfo?.serving?.size) {
      const unit = this.getUnitAbbreviation(this.foodAllInfo.serving?.unit);
      return Math.round(this.foodAllInfo.serving.size) + ' ' + unit;
    }
    // For multi-item meals, convert all to grams and sum
    if (!this.foodAllInfo?.foodItems) {
      return '';
    }
    const totalGrams = this.foodAllInfo.foodItems.reduce((sum: number, item: any) => {
      const size = item.serving?.size || 0;
      const unit = (item.serving?.unit || 'grams').toLowerCase();
      const sizeInGrams = this.convertToGrams(size, unit);
      return sum + sizeInGrams;
    }, 0);
    if (totalGrams > 0) {
      return Math.round(totalGrams) + ' g';
    }
    return '';
  }

  convertToGrams(size: number, unit: string): number {
    const unitLower = unit.toLowerCase();
    if (unitLower === 'grams' || unitLower === 'g') {
      return size;
    } else if (unitLower === 'ounces' || unitLower === 'oz') {
      return size * 28.35;
    } else if (unitLower === 'fluid ounces' || unitLower === 'fl oz' || unitLower === 'floz') {
      // Approximate: 1 fl oz ≈ 29.57 ml ≈ 29.57 g (for water-based liquids)
      return size * 29.57;
    } else if (unitLower === 'cups' || unitLower === 'cup') {
      return size * 236.59; // 1 cup ≈ 236.59 ml/g
    } else if (unitLower === 'ml' || unitLower === 'milliliters') {
      return size; // 1 ml ≈ 1 g for water-based liquids
    } else if (unitLower === 'liters' || unitLower === 'l') {
      return size * 1000;
    }
    return size; // Default: assume grams
  }

  getUnitAbbreviation(unit: string): string {
    if (!unit) return 'g';
    const unitLower = unit.toLowerCase();
    if (unitLower === 'fluid ounces' || unitLower === 'fl oz' || unitLower === 'floz') {
      return 'fl oz';
    } else if (unitLower === 'ounces' || unitLower === 'oz') {
      return 'oz';
    } else if (unitLower === 'cups' || unitLower === 'cup') {
      return 'cups';
    } else if (unitLower === 'grams' || unitLower === 'g') {
      return 'g';
    }
    return unit; // Return as-is if unknown
  }
}